import React from 'react';
import styles from './table.module.scss';
import TableSkeleton from '../Skeletons/TableSkeleton';

function Table({ cols = [], data = [], pendingFetch = false }) {
  return (
    <table className={`table text-center ${styles.table}`}>
      <thead>
        <tr>
          {cols.map((headerItem, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <th className={headerItem?.headerClass} key={index}>
              {headerItem.title}
            </th>
          ))}
        </tr>
      </thead>
      {pendingFetch ? (
        <tbody data-testid="body">
          {Array.from({ length: 5 }, (v, k) => k).map((_, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableSkeleton key={idx} qty={6} />
          ))}
        </tbody>
      ) : (
        <tbody data-testid="body">
          {data?.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={index}>
              {cols?.map((col, ind) => (
                // eslint-disable-next-line react/no-array-index-key
                <td className={col?.dataClass} key={ind}>
                  {col.render(item)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      )}
    </table>
  );
}

export default Table;
